module.exports = __webpack_public_path__ + "static/media/logokpru.78cc9560.png";